import { LayerType } from '@pn/core/domain/layer';
import { buildQuery } from '@pn/core/domain/query';
import {
  createInitInternalState,
  ItemsFolder,
  type WorkspaceItem,
} from '@pn/core/domain/workspace';
import { isProduction } from '@pn/core/utils/env';
import { DEFAULT_POLYGON_OPACITY } from '@pn/services/styles';
import { generateMapConfig, setOriginalLayers } from '.';

export const pools: WorkspaceItem = setOriginalLayers({
  country: 'canada',
  folder: ItemsFolder.Public,
  isTemporary: false,
  id: 'pools',
  dataType: 'pools',
  itemType: 'layer',
  numberOfElements: undefined,
  createdBy: undefined,
  name: 'Pools',
  description: '60k pools in Canada',
  origin: 'pn',
  createdAt: '1970-01-01T00:00:00.000Z',
  updatedAt: '1970-01-01T00:00:00.000Z',
  isShared: false,
  isGlobal: true,
  map: generateMapConfig({
    itemId: 'pools',
    type: LayerType.Polygon,
    style: {
      color: `hsla(230, 50%, 60%, ${DEFAULT_POLYGON_OPACITY})`,
    },
    source: {
      type: 'vector',
      minzoom: 6,
      maxzoom: 10,
      tiles: [
        isProduction()
          ? 'https://tiles.stackdx.com/pools/{z}/{x}/{y}.pbf'
          : 'https://staging-tiles.stackdx.com/pools/{z}/{x}/{y}.pbf',
      ],
    },
    sourceLayer: 'pools',
    renderAsPoints: true,
  }),
  dataSource: {
    type: 'api',
    source: 'parquet',
    url: 'v2/layers/pools',
    requiredMapDataFields: ['internal_id', 'geometry'],
    requiredTableDataFields: [
      'internal_id',
      'geometry',
      'field_code',
      'pool_code',
      'pool_name',
      'field_name',
    ],
  },
  detailsSource: 'api',
  query: buildQuery({
    id: 'pools',
    dataType: 'pools',
  }),
  ...createInitInternalState({ isVisualized: false }),
});
